"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonPostProcess = void 0;
const tslib_1 = require("tslib");
const cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
function recursiveFinder(matches, node, path) {
    if (node === undefined || node === null) {
        return;
    }
    if (Array.isArray(node)) {
        for (let index = 0; index < node.length; index++) {
            // Apply recursion
            recursiveFinder(matches, node[index], [...path, index]);
        }
        return;
    }
    if (typeof node === "object") {
        let match;
        for (const [key, child] of Object.entries(node)) {
            // Apply recursion
            recursiveFinder(matches, child, [...path, key]);
            match = key.match(/^__drop__[^_]*$/);
            if (match) {
                matches.drop.push({ key, node });
                continue;
            }
            match = key.match(/^__json__(?<cleanKey>[^_]+)$/);
            if (match === null || match === void 0 ? void 0 : match.groups) {
                matches.json.push({ key, node, cleanKey: match.groups.cleanKey });
                continue;
            }
            match = key.match(/^__first__(?<cleanKey>[^_]+)$/);
            if (match === null || match === void 0 ? void 0 : match.groups) {
                matches.first.push({ key, node, cleanKey: match.groups.cleanKey });
                continue;
            }
            match = key.match(/^(?<first>__first)?__source_((?<id>[A-Za-z][0-9A-Za-z]*)_)?_(?<cleanKey>.+)$/);
            if (match === null || match === void 0 ? void 0 : match.groups) {
                const id = match.groups.id || match.groups.cleanKey;
                const first = !!match.groups.first;
                matches.source.push({ key, node, path, id, first });
                continue;
            }
            match = key.match(/^(?<first>__first)?__target_((?<id>[A-Za-z][0-9A-Za-z]*)_)?_(?<cleanKey>.+)$/);
            if (match === null || match === void 0 ? void 0 : match.groups) {
                const cleanKey = match.groups.cleanKey;
                const id = match.groups.id || cleanKey;
                const first = !!match.groups.first;
                matches.target.push({
                    key,
                    node,
                    path,
                    id,
                    cleanKey,
                    first,
                });
                continue;
            }
        }
    }
}
// A recursive finder that locates nodes eligible for post-processing
function finder(root) {
    const matches = { drop: [], first: [], json: [], source: [], target: [] };
    recursiveFinder(matches, root, []);
    return matches;
}
/**
 * Takes a typical graphql response from CraftCMS and applies some post processing
 *
 * __drop__ will remove the field
 * __json__ will replace a JSON encoded string with its parsed equivalent
 * __first__ will replace an array field with the value of the first element of the array
 * __source__ will make the field value available to a __target__
 * __target__ will use the field value or the value from an associated __source__ field
 */
function jsonPostProcess(value) {
    var _a;
    // Clone and find eligible nodes
    const clone = cloneDeep_1.default(value);
    const { drop, json, first, source, target } = finder(clone);
    // Post process '__drop__'
    for (const { key, node } of drop) {
        delete node[key];
    }
    // Post process '__json__'
    for (const { key, node, cleanKey } of json) {
        switch (node[key]) {
            case null:
                node[cleanKey] = null;
                break;
            case undefined:
                node[cleanKey] = undefined;
                break;
            default: {
                const v = node[key];
                try {
                    node[cleanKey] = typeof v === "string" ? JSON.parse(v) : undefined;
                }
                catch (_b) {
                    node[cleanKey] = undefined;
                }
                break;
            }
        }
        delete node[key];
    }
    // Post process '__first__'
    for (const { key, node, cleanKey } of first) {
        const v = node[key];
        node[cleanKey] = Array.isArray(v) ? v === null || v === void 0 ? void 0 : v[0] : undefined;
        delete node[key];
    }
    // Post process '__source__'
    const sourceValueMap = {};
    for (const { key, node, path, id, first } of source) {
        for (let end = path.length; end >= 0; end--) {
            const k = `${id}[${path.slice(0, end).join(".")}]`;
            const v = node[key];
            sourceValueMap[k] = {
                count: (((_a = sourceValueMap[k]) === null || _a === void 0 ? void 0 : _a.count) || 0) + 1,
                value: first && Array.isArray(v) ? v === null || v === void 0 ? void 0 : v[0] : v,
            };
        }
        delete node[key];
    }
    function getValueFromSource(path, id) {
        const k = `${id}[${path.slice(0, path.length).join(".")}]`;
        const container = sourceValueMap[k];
        if ((container === null || container === void 0 ? void 0 : container.count) === 1) {
            return container.value;
        }
        return undefined;
    }
    // Post process '__target__'
    for (const { key, node, path, id, cleanKey, first } of target) {
        const v = node[key];
        const value = first && Array.isArray(v) ? v === null || v === void 0 ? void 0 : v[0] : v;
        if (Array.isArray(value) && value.length === 0) {
            node[cleanKey] = getValueFromSource(path, id) || value;
        }
        else {
            node[cleanKey] = value || getValueFromSource(path, id);
        }
        delete node[key];
    }
    return clone;
}
exports.jsonPostProcess = jsonPostProcess;
//# sourceMappingURL=index.js.map